import React, { useState } from "react";
import AdminDetailsCard from "./adminLayouts/adminDetailsSide";
import AdminTable from "./adminLayouts/adminTable";
import Paginate from "../layout/paginate";
import Titlebar from "../layout/titlebar";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import { customStyle } from "../../algorithms/styleDirection";

const AdminHome = ({
  data,
  currentPage,
  setCurrentPage,
  title,
  listType,
  modalVisible,
  setModalVisible,
}) => {
  const [rowInfo, setRowInfo] = useState({
    show: false,
    id: null,
    userData: {},
  });
  return (
    <>
      <div
        className="d-flex flex-wrap align-content-start position-relative"
        style={{ color: "#0C574C" }}
      >
        <Titlebar
          // hasIcon
          // icon={
          //   <Icon
          //     iconPrefix={"fas"}
          //     name={listType == "users" ? "user" : "users"}
          //     color={"#1A73E8"}
          //     size={24}
          //     className="mx-1 "
          //   />
          // }
          customImage={
            listType == "users"
              ? "/assets/images/icon3.svg"
              : listType == "lookups"
              ? ""
              : "/assets/images/icon4.svg"
          }
          imgHeight={26}
          imgWidth={22}
          title={title}
        />
        <div className="col-lg-8 col-12 order-lg-0  order-1">
          {/* <div className="d-flex justify-content-start my-3 px-3 flex-wrap">
            <TextInput
              onChange={() => {}}
              // errorMessage={"ff"}
              type={"text"}
              hiddenPlaceholder={Lang.finish}
              containerStyle={"col-6 col-md-3  px-1"}
              height={32}
            ></TextInput>
          </div> */}
          <AdminTable
            data={
              listType == "lookups"
                ? data?.data?.map((item) => {
                    return {
                      Name_E: item?.name_E,
                      Name_A: item?.name_A,
                      Description_A: item?.description_A,
                      Description_E: item?.description_E,
                      Active: item?.active,
                      Focus: item?.focus,
                      SortIndex: item?.sortIndex,
                      Color: item?.color,
                      IsDefault: item?.isDefault,
                    };
                  })
                : data?.data
            }
            currentPage={currentPage}
            setRowInfo={setRowInfo}
            rowInfo={rowInfo}
          />
        </div>
        <div className="flex-column my-3 my-lg-0 align-self-center justify-content-center align-items-center col-lg-4 col-12  ">
          {!rowInfo.show ? (
            <div className=" d-flex justify-content-center  col-12 align-items-center mx-3 my-1 flex-wrap">
              <CardWithTitleAndIcon
                containerStyle={`d-flex flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4  ${customStyle(
                  "createTaskButton"
                )}`}
                borderColor={"rgba(68, 68, 68, 0.25)"}
                height={180}
                width={180}
                customImage={
                  listType == "users"
                    ? "/assets/images/addicon3.svg"
                    : listType == "lookups"
                    ? "/assets/images/addLookup.png"
                    : "/assets/images/addicon4.svg"
                }
                imgHeight={70}
                imgWidth={80}
                containerImgHeight={70}
                containerImgWidth={80}
                cardTitle={
                  listType == "users"
                    ? " إضافة مستخدم"
                    : listType == "lookups"
                    ? "lookup"
                    : " إضافة محور عمل "
                }
                onClick={() => {
                  listType == "communities" &&
                    setModalVisible({ ...modalVisible, addCommunity: true });
                  listType == "users" &&
                    setModalVisible({ ...modalVisible, addUserData: true });
                  listType == "lookups" &&
                    setModalVisible({ ...modalVisible, addLookup: true });
                }}
                boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
              />
            </div>
          ) : (
            <AdminDetailsCard
              listType={listType}
              setRowInfo={setRowInfo}
              rowInfo={rowInfo}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          )}
        </div>
      </div>
      {setCurrentPage && (
        <div className=" mt-2 d-flex justify-content-center w-100">
          <Paginate
            pageCount={Math.ceil(data?.count / 10)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </>
  );
};

export default AdminHome;
